module.exports = __webpack_public_path__ + "img/vn-2-shifting-investment.774a11f4.jpg";